export const waypointsAheadText = numberOfWaypointsAhead => {
  const isPlural = numberOfWaypointsAhead > 1;
  return `There ${isPlural ? 'are' : 'is'} ${numberOfWaypointsAhead} stop${isPlural ? 's' : ''} ahead of you`;
};



// WEBPACK FOOTER //
// ./src/app/order-card/pending/header/utils/waypointsAhead.js